
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import { mdiClose } from '@mdi/js';

	const Props = Vue.extend({
		props: {
			/** The v-model value */
			value: {
				type: Boolean,
				default: false
			},
			/** The title of the Dialog */
			title: {
				type: String,
				default: undefined
			},
			subTitle: {
				type: String,
				default: undefined
			},
			cancelBtnText: {
				type: String,
				default: 'Annuler'
			},
			confirmBtnText: {
				type: String,
				default: 'Confirmer'
			},
			suppressBtnText: {
				type: String,
				default: 'Supprimer'
			},
			confirmBtnDisabled: {
				type: Boolean,
				default: false
			},
			suppressBtnDisabled: {
				type: Boolean,
				default: false
			},
			cancelBtnDisplayed: {
				type: Boolean,
				default: true
			},
			suppressBtnDisplayed: {
				type: Boolean,
				default: false
			},
			confirmBtnDisplayed: {
				type: Boolean,
				default: true
			},
			/** Full loading */
			loading: {
				type: Boolean,
				default: false
			},
			/** Puts the confirm button in loading state */
			formLoading: {
				type: Boolean,
				default: false
			},
			dataCy: {
				type: String,
				default: ''
			}
		}
	});

	/** Displays a VDialog with a VCard and confirm/cancel buttons */
	@Component<PopUp>({
		// Disable attributes inheritance because
		// we bind them manually
		inheritAttrs: false,

		// v-model
		model: {
			prop: 'value',
			event: 'change'
		}
	})
	export default class PopUp extends Props {

		confirmBtnDisabled!: boolean;
		// Icons
		closeIcon = mdiClose;

		// temporary disabling strategy
		delay = 2000;
		timer: any = 0;
		isTemporaryDisabled = false;

		/** Internal v-model for the dialog */
		get internalDialog(): boolean {
			return this.value;
		}

		set internalDialog(value: boolean) {
			this.$emit('change', value);
		}

		get isConfirmBtnDisabled(): boolean {
			return this.confirmBtnDisabled || this.isTemporaryDisabled;
		}

		created() {
			// Close popup on ESC key press.
			document.addEventListener('keyup', (event) => {
				if (27 === event.keyCode) {
					this.$emit('close');
				}
			});
		}

		confirmAction(): void {
			this.$emit('confirm');
			this.temporaryDisabling();
		}

		suppressAction(): void {
			this.$emit('suppress');
			this.temporaryDisabling();
		}

		temporaryDisabling(): void {
			this.isTemporaryDisabled = true;
			this.timer = setTimeout( () => {
				this.isTemporaryDisabled = false;
				clearTimeout(this.timer);
			}, this.delay);
		}
	}
